// !Depends on the menu ids in header.js
// !The modelMapper here has to be updated in case if a new menu entry is added or updated in (constants/mdm-v2/header.js)
// !The modelMapper Object in (constants/model-constants.js) has to be updated if the modelMapper in this file is modified.
const modelMapper = {
  base_fuel_rate: 'mdmBdr',
  contract: 'mdmContract',
  Role: 'mdmRole',
  User: 'mdmUser',
  Depot: 'mdmDepot',
  extra_drop_off_charge: 'mdmDropOff',
  mdmLocation: 'mdmLocations',
  Consignee: 'mdmConsignee',
  Transporter: 'mdmTransporter',
  materialcategory: 'mdmMaterialCategory',
  contracttsd: 'mdmContractTsd',
  Detention: 'mdmDetention',
  Driver: 'mdmDriver',
  sla: 'mdmSla',
  Material: 'mdmMaterials',
  Vehicle: 'mdmVehicles',
  destination_charge: 'mdmDestinationCharge',
  exceptions: 'mdmRejections',
  loading: 'mdmLoadingUnloading',
  Bucc: 'mdmBucc',
  purchase_order: 'mdmPurchaseOrder',
  transit_management: 'mdmTransitManagement',
  VendorDepots: 'mdmVendorDepot',
  Port: 'mdmPorts',
  CHA: 'mdmCha',
  Container: 'mdmContainer',
  FreightForwarder: 'mdmFreightFowarder',
  dedicatedtruck: 'mdmDedicatedTrucks',
  BillDiscount: 'mdmBillDisc',
  package_master: 'mdmPackageMaster',
  material_package_map: 'mdmMaterialPackageMapping',
  route_master: 'mdmRoute',
  activity_time: 'mdmActivityTime',
  VehicleDetail: 'mdmVehicleDetails',
  transshipment: 'mdmTransshipment',
  source_charge: 'mdmSourceCharge',
  redirection: 'mdmRedirection',
  freight_zone: 'mdmFreightZone',
  legal_entity: 'mdmLegalEntity',
  budget: 'mdmBudget',
};

const bfrMapper = {
  bfr: 'base_fuel_rate',
  base_fuel_rate: 'bfr',
};

module.exports = {
  modelMapper,
  bfrMapper,
};
